module.exports = __webpack_public_path__ + "static/media/69 - AIESEC UI LOGO BLUE.ad15ba88.png";